import type { Task } from "../types.js";

export interface DetailRow {
  label: string;
  value: string;
}

export function taskDetailRows(t: Task): DetailRow[] {
  const rows: DetailRow[] = [];
  if (t.spec) rows.push({ label: "Spec", value: t.spec });
  if (t.riskTier) rows.push({ label: "Risk", value: t.riskTier });
  if (t.priority) rows.push({ label: "Priority", value: t.priority });
  if (t.dependsOn?.length) rows.push({ label: "Depends on", value: t.dependsOn.join(", ") });
  if (t.touchPaths?.length) rows.push({ label: "Touches", value: t.touchPaths.join(", ") });
  if (t.tags?.length) rows.push({ label: "Tags", value: t.tags.join(", ") });
  const checks = t.acceptance?.verifyCmds?.length ?? 0;
  if (checks > 0) rows.push({ label: "Checks", value: String(checks) });
  return rows;
}
